window.FazendaRP = window.FazendaRP || {};

// Router Module
window.FazendaRP.loadPage = async function (pageName) {
    const mainContent = document.getElementById('main-content');

    try {
        if (pageName.startsWith('financeiro')) {
            const parts = pageName.split('_');
            let subPage = parts[1] || 'dashboard'; // 'dashboard', 'agenda', 'novo-lancamento', etc.

            // Map common shortcuts
            if (subPage === 'novo') subPage = 'novo-lancamento';

            if (window.FazendaRP.Pages && window.FazendaRP.Pages.financeiro) {
                window.FazendaRP.Pages.financeiro.render(mainContent, subPage);
            } else { throw new Error("Módulo Financeiro não carregado."); }
            return;
        }

        if (pageName === 'safra') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.Safra) {
                window.FazendaRP.Pages.Safra.init(mainContent);
            } else { throw new Error("Módulo Safra não carregado. Verifique index.html"); }
            return;
        }

        if (pageName === 'suprimentos') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.suprimentos) {
                window.FazendaRP.Pages.suprimentos.render(mainContent);
            } else { throw new Error("Módulo Suprimentos não carregado."); }
            return;
        }

        if (pageName === 'maquinas') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.maquinas) {
                window.FazendaRP.Pages.maquinas.render(mainContent);
            } else { throw new Error("Módulo Máquinas não carregado."); }
            return;
        }

        if (pageName === 'operacional') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.operacional) {
                window.FazendaRP.Pages.operacional.init(mainContent);
            } else { throw new Error("Módulo Operacional não carregado."); }
            return;
        }

        if (pageName === 'sistema') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.sistema) {
                window.FazendaRP.Pages.sistema.render(mainContent);
            } else { throw new Error("Módulo Sistema não carregado."); }
            return;
        }

        if (pageName === 'relatorios') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.Relatorios) {
                window.FazendaRP.Pages.Relatorios.init(mainContent);
            } else { throw new Error("Módulo Relatórios não carregado."); }
            return;
        }

        if (pageName === 'clima') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.clima) {
                window.FazendaRP.Pages.clima.render(mainContent);
            } else { throw new Error("Módulo Clima não carregado."); }
            return;
        }

        if (pageName === 'whatsapp') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.whatsapp) {
                window.FazendaRP.Pages.whatsapp.render(mainContent);
            } else { throw new Error("Módulo WhatsApp não carregado."); }
            return;
        }

        if (pageName === 'ir') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.ir) {
                window.FazendaRP.Pages.ir.render(mainContent);
            } else { throw new Error("Módulo Fiscal/IR não carregado."); }
            return;
        }

        if (pageName === 'conciliacao') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.conciliacao) {
                window.FazendaRP.Pages.conciliacao.render(mainContent);
            } else { throw new Error("Módulo Conciliação não carregado."); }
            return;
        }

        if (pageName === 'auditoria') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.Auditoria) {
                window.FazendaRP.Pages.Auditoria.render(mainContent);
            } else { throw new Error("Módulo Auditoria não carregado."); }
            return;
        }

        // Dashboard e Fallback
        if (pageName === 'dashboard') {
            if (window.FazendaRP.Pages && window.FazendaRP.Pages.dashboard) {
                window.FazendaRP.Pages.dashboard.render(mainContent);
            } else {
                window.FazendaRP.renderDashboardPlaceholder(mainContent); // Fallback old
            }
        } else {
            mainContent.innerHTML = `
                <div class="card">
                    <div style="text-align: center; padding: 40px;">
                        <i class="fas fa-tools fa-3x" style="color: var(--text-muted); margin-bottom: 20px;"></i>
                        <h2>Página em Construção</h2>
                        <p>O módulo <strong>${pageName}</strong> está sendo desenhado.</p>
                    </div>
                </div>
            `;
        }

    } catch (error) {
        console.error('Erro ao renderizar página:', error);
        mainContent.innerHTML = `
            <div class="error-state" style="color: var(--color-danger); text-align: center; padding: 40px;">
                <p>Erro ao exibir componente: ${pageName}</p>
                <small>${error.message}</small>
            </div>
        `;
    }
};

// Placeholder Dashboard
window.FazendaRP.renderDashboardPlaceholder = function (container) {
    container.innerHTML = `
        <div class="dashboard-financeiro">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
                <h2>Visão Geral da Fazenda</h2>
                <span style="font-size: 0.8rem; color: var(--text-muted);">Fazenda Rio do Peixe (FR)</span>
            </div>
            <div class="grid-resumo" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 20px; margin-bottom: 30px;">
                <div class="card">
                    <div style="color: var(--text-muted); font-size: 0.9rem;"><i class="fas fa-sun"></i> Clima</div>
                    <div style="font-size: 1.5rem; font-weight: bold; color: var(--color-accent);">28°C</div>
                </div>
                <div class="card">
                    <p>Bem Vindo ao novo sistema Web!</p>
                </div>
            </div>
        </div>
    `;
};
